module.exports = __webpack_public_path__ + "img/eth_ropsten.e83b9222.svg";